/**
 * @ngdoc Filter
 * @name widgetFilter
 */
(function() {
    'use strict';

    // Note: widget type filter has been moved to 'codeToType.js' in the Vue part of the project.
    angular.module('vrm.components')
        // For some reason some widgets have different codes and endpoints... map them
        .constant('widgetTypeMapping', {
            'State' : 'VeBusState',
            'BatteryTempSensor' : 'BatteryTemperature',
            'IOExtenderTempSensor': 'IOExtenderTemperature',
            'MotorTemperatureAndControllerTemperature' : 'MotorAndControllerTemperature'
        });
})();
